import React, { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";
import JisDialogForm from "../../formdialog";

function ViewMotions({ caseId, motions = null, isAction = false }) {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);

  const [loading, setLoading] = useState(false);
  const [_motions, setMotions] = useState(motions);
  const [prayerPreview, setPrayerPreview] = useState(null);

  useEffect(() => {
    /*  if(motions==null){
            onLoad();
          } */
  }, [motions]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseId}/motions`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      if (data.code == 0) {
        setMotions(data.motions);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onFilingMotion = () => {
    navigate(`/filing-motion/${caseId}`);
  };

  return (
    <div>
      {isAction && (
        <div style={{ textAlign: "right" }}>
          <button className="btn-solid add-motion-btn" onClick={onFilingMotion}>
            File a new motion
          </button>
        </div>
      )}

      <div className="table-header">
        <p>Motion </p>
      </div>
      <div className="table-wrapper">
        <table class="case-details-table full-border">
          <thead>
            <tr>
              <th className="col-title">Motion Classification</th>
              <th>Party</th>
              <th className="col-medium">Motion Type</th>
              <th>Filed On</th>
              <th>View Prayers Sought</th>
              {/* <th>Further Affidavit</th> */}
            </tr>
          </thead>
          <tbody>
            {_motions.map((opt) => (
              <tr key={opt.id}>
                <td>{opt.motionClass || "N/A"}</td>
                <td>
                  {opt.party.firstName || opt.party.lastName
                    ? `${opt.party.firstName} ${opt.party.lastName ?? ""}`
                    : "N/A"}
                  {/* {opt.party.firstName} {opt.party.lastName ?? ""} */}
                </td>
                <td>{opt.motiontype || "N/A"}</td>
                <td>
                  {opt.createdOn
                    ? Constants.momentDate(opt.createdOn).format("DD MMM, YYYY")
                    : "N/A"}
                </td>
                <td>
                  <JisButton
                    onClick={() => setPrayerPreview(opt?.prayers)}
                    variant="plain"
                  >
                    Preview
                  </JisButton>
                </td>
                {/* <td>
                  <JisButton variant="plain">Add</JisButton>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <div className="motions">
        {_motions.map((opt) => (
          <div class="motion-card" key={opt.id}>
            <div class="motion-section">
              <div class="motion-left">
                <p>
                  <strong>Prayers</strong>
                </p>
                <ol>
                  {opt.prayers?.map((pray, ind) => (
                    <li key={pray.id} style={{ gap: 10, display: "flex" }}>
                      <span>{ind + 1}.</span>
                      <span>{pray.prayer}</span>{" "}
                    </li>
                  ))}
                </ol>
              </div>
              <div class="motion-divider"></div>
              <div class="motion-right">
                <p>
                  <strong>Party Name: </strong> {opt.party.firstName}{" "}
                  {opt.party.lastName ?? ""}
                </p>
                <p>
                  <strong>Motion Type: </strong> {opt.motiontype}
                </p>
                <p>
                  <strong>Classification: </strong>
                  {opt.motionClass}
                </p>
                <p>
                  <strong>Date Filed: </strong>{" "}
                  {Constants.momentDate(opt.createdOn).format("DD MMM, YYYY")}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div> */}
      {prayerPreview && (
        <JisDialogForm
          title="Prayers"
          onClose={() => setPrayerPreview(null)}
          minWidth="40%"
        >
          <div
            style={{
              maxWidth: "680px",
            }}
          >
            <ul style={{ gap: 10, display: "flex", flexDirection: "column" }}>
              {prayerPreview?.map((pray, ind) => (
                <li
                  style={{
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                  key={pray.id}
                >
                  <span
                    style={{
                      marginRight: 8,
                    }}
                  >
                    {ind + 1}.
                  </span>
                  <span>{pray.prayer}</span>
                </li>
              ))}
            </ul>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default ViewMotions;
